export default "__VITE_ASSET__DSncDzBX__"